import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

// Interfaces
import { Modal as ModalInterface } from '../../interfaces/modal';

const Modal = ({
  modalType,
  isShowing,
  hide,
  children,
  handleClose,
  isCookies,
  align,
}: ModalInterface) => {
  const WrapperRef = useRef<any>(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (WrapperRef.current && !WrapperRef.current.contains(event.target)) {
        hide;
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [WrapperRef]);

  return (
    <React.Fragment>
      {isShowing && typeof document !== 'undefined'
        ? ReactDOM.createPortal(
            <div className='cl-modal-backdrop' ref={WrapperRef}>
              <dialog
                className={`cl-modal ${
                  modalType === 'Popup' ? 'cl-modal--popup' : ''
                } text-${align}`}
                open
              >
                <button
                  type='button'
                  className='cl-button cl-button--sm cl-modal__close'
                  data-dismiss='modal'
                  aria-label='Close'
                  onClick={isCookies ? handleClose : hide}
                >
                  <span className='relative only:-mx-4'>
                    <span className='sr-only'>Close Button</span>
                    <svg
                      width='17'
                      height='17'
                      viewBox='0 0 17 17'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M3.5 13.5L13.5 3.5'
                        stroke='#201D1B'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M3.5 3.5L13.5 13.5'
                        stroke='#201D1B'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </span>
                </button>

                {children}
              </dialog>
            </div>,
            document.body,
          )
        : null}
    </React.Fragment>
  );
};

export default Modal;
